import Button from "@amzn/meridian/esm/components/button";
import Column from "@amzn/meridian/esm/components/column";
import Icon from "@amzn/meridian/esm/components/icon";
import Link from "@amzn/meridian/esm/components/link";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";
import chevronDownTokens from "@amzn/meridian-tokens/base/icon/chevron-down-small";
import chevronUpTokens from "@amzn/meridian-tokens/base/icon/chevron-up-small";
import { typographyH50FontWeight } from "@amzn/meridian-tokens/base/typography";
import { PHONE_TOOL_USER_BASE } from "../../constants";
import { THEME_COLOR } from "../../styles/colors";
import { openUrl } from "../../utils/zoomSdkUtils";
import { MISSING_VALUE } from "./whosWho.constants";
import InsightSlot from "./InsightSlot";

const ROLE_TEXT_TOKENS = {
  textB100FontWeight: typographyH50FontWeight,
  textColorPrimary: THEME_COLOR.CHARCOAL_GRAY,
};

const InviteeOverview = ({
  person,
  isError,
  canExpand,
  pinnedInsight,
  expanded,
  onToggle,
}) => {
  const isExternal = person.external;
  const showField = (value) => {
    if (isError) return MISSING_VALUE;
    return value || MISSING_VALUE;
  };
  const phoneToolUrl = `${PHONE_TOOL_USER_BASE}${person.alias}`;

  const disclosureIconTokens = expanded ? chevronUpTokens : chevronDownTokens;

  const roleLabel = isExternal ? "External" : showField(person.role);
  const organizationOrEmail = isExternal
    ? person.email || MISSING_VALUE
    : showField(person.org);

  return (
    <Row
      width="100%"
      widths={["fill", "fit"]}
      spacing="200"
      alignmentVertical="top"
    >
      <Column spacing="200" width="fill">
        <Row spacing="200" alignmentVertical="center" wrap="down">
          {!isExternal && !isError && person.alias ? (
            <Link
              onClick={() => openUrl(phoneToolUrl)}
              type="primary"
            >
              <Theme tokens={{ textColorPrimary: THEME_COLOR.TEAL_GREEN }}>
                <Text type="h50">{person.name}</Text>
              </Theme>
            </Link>
          ) : (
            <Text type="h50">{person.name}</Text>
          )}
          {!isExternal && (
            <Text type="b100" color="secondary">· {showField(person.level)}</Text>
          )}
        </Row>

        <Row spacing="200" alignmentVertical="center" wrap="down">
          <Theme tokens={ROLE_TEXT_TOKENS}>
            <Text type="b100" color="primary">{roleLabel}</Text>
          </Theme>
          <Text type="b100" color="secondary" breakWord>
            {`|\u00A0${organizationOrEmail}`}
          </Text>
        </Row>

        {!isExternal && (
          <Row spacing="200" alignmentVertical="center" wrap="down">
            <Text type="b100" color="secondary">{showField(person.location)}</Text>
            {canExpand && pinnedInsight && (
              <Row spacing="200" alignmentVertical="center">
                <Text type="b100" color="secondary">|</Text>
                <InsightSlot insight={pinnedInsight} />
              </Row>
            )}
          </Row>
        )}
      </Column>

      {canExpand && (
        <Button
          type="icon"
          size="small"
          onClick={onToggle}
        >
          <Icon tokens={disclosureIconTokens} color="secondary" />
        </Button>
      )}
    </Row>
  );
};

export default InviteeOverview;
